import React from "react";
import { REPORT_PAGES_ROUTES } from "../../../../constants";
import { filterByLink } from "../../../../store/issuesSlice";
import { assessmentCategoryWithStateFiltered } from "../../../../store/policiesSlice";
import { RiskCards } from "../../../../ui";
import { LinkToReportTab } from "../../../common";
import { useReportDispatch } from "../../../hooks";
import styles from "./assessmentCard.module.scss";
const RiskWrapper = ({ type, children, riskStats, isReproRisk, assessmentCategory, }) => {
    const dispatch = useReportDispatch();
    if (type === "total") {
        return (React.createElement(LinkToReportTab, { id: `${assessmentCategory}-all-risks-link`, to: REPORT_PAGES_ROUTES.ISSUES_ROUTE, color: "link", className: styles["all-risks-link"], onClick: () => dispatch(filterByLink({
                assessment_category: {
                    operation: "is",
                    values: [assessmentCategory],
                },
            })) }, children));
    }
    else if (type === "other") {
        return (React.createElement(LinkToReportTab, { id: `${assessmentCategory}-other-risks-link`, to: REPORT_PAGES_ROUTES.ISSUES_ROUTE, className: styles["secondary-link"], onClick: () => dispatch(filterByLink({
                assessment_category: {
                    operation: "is",
                    values: [assessmentCategory],
                },
            })) }, children));
    }
    else if (type === "label") {
        return (React.createElement(LinkToReportTab, { underline: "hover", id: `${riskStats.label}-link`, to: isReproRisk
                ? REPORT_PAGES_ROUTES.REPRODUCIBILITY_ROUTE
                : REPORT_PAGES_ROUTES.ISSUES_ROUTE, onClick: () => {
                if (!isReproRisk)
                    dispatch(filterByLink({
                        issue: { operation: "is_any", values: riskStats.violations },
                    }));
            } }, children));
    }
    else {
        return React.createElement(React.Fragment, null, children);
    }
};
const AssessmentCard = ({ assessmentCategory, riskAssessment, policyCount, }) => {
    const dispatch = useReportDispatch();
    return (React.createElement(RiskCards.AssessmentCard, { assessmentCategory: assessmentCategory, riskAssessment: riskAssessment, policyCount: policyCount, policiesWrapper: (type, children) => (React.createElement(LinkToReportTab, { id: `${assessmentCategory}-${type}-policies-link`, to: REPORT_PAGES_ROUTES.POLICIES_ROUTE, className: styles["policies-link"], onClick: () => dispatch(assessmentCategoryWithStateFiltered({
                policy_state: type,
                assessment_category: assessmentCategory,
            })) }, children)), risksWrapper: (props) => (React.createElement(RiskWrapper, { ...props, assessmentCategory: assessmentCategory })) }));
};
export default AssessmentCard;
//# sourceMappingURL=AssessmentCard.js.map